import { TextField } from "@mui/material";

export const StyledTextField = (props) => (
    <TextField
    {...props}
        sx={{
            "& .MuiInputBase-root": {
                height: { xs: 40, md: 40 },
            }
        }}
    >
    </TextField>
);